/**
 * Commissions module layout: the module heading and its top tab bar, then the
 * active tab's screen.
 *
 * Same top-nav component as every other labs module (the @andavo/web-ui pill
 * Tabs that CrmModuleShell and ExpenseLayout render), with the tab list read
 * from the PAGE REGISTRY (moduleTabs('commissions')), so the rail, this tab
 * bar and Admin > Users describe the same access. A Hotel tab is one more
 * page-registry entry plus its route; nothing here changes.
 *
 * Why not CrmModuleShell: it mounts the cm-api /me provider and the .crm-scope
 * styles (this module uses neither), and it hides the tab bar when only one
 * tab is visible, while the owner asked for a visible Air tab from day one.
 *
 * The module is FULL-BLEED (routes-registry fullBleedPaths): the workbench owns
 * its columns and scrolling like chat does, so this layout is a full-height
 * column with the tab strip on top and the screen filling the rest.
 *
 * Rendered only behind CommissionsGate (routes.tsx), so the tab bar never
 * advertises the module to someone the gate keeps out.
 */
import { Tabs, TabsList, TabsTrigger } from '@andavo/web-ui';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { moduleTabs } from '@/features/admin/lib/page-registry';

export const COMMISSIONS_TABS = moduleTabs('commissions');

export function CommissionsLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const activeIndex = Math.max(
    0,
    COMMISSIONS_TABS.findIndex((t) => pathname.startsWith(t.path)),
  );
  const activeValue = COMMISSIONS_TABS[activeIndex]?.value ?? '';

  return (
    <div className="flex h-full min-h-0 w-full flex-col">
      <div className="flex shrink-0 flex-wrap items-center gap-x-6 gap-y-2 border-border-subtle border-b bg-surface-background px-4 py-3 sm:px-6">
        <h1 className="font-sans font-semibold text-2xl text-content-primary">
          Commissions
        </h1>
        <Tabs
          onValueChange={(value) => {
            const next = COMMISSIONS_TABS.find((t) => t.value === value);
            if (next) navigate(next.path);
          }}
          value={activeValue}
        >
          <TabsList initSelectedIndex={activeIndex}>
            {COMMISSIONS_TABS.map((t) => (
              <TabsTrigger key={t.value} value={t.value}>
                {t.text}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </div>
      <div className="flex min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
